import * as Yup from 'yup'

export const giftSubscriptionSchema = Yup.object().shape({
  dueDate: Yup.date()
    .transform(function(value, originalValue) {
      if (this.isType(value)) {
        return value
      }
      return originalValue
    })
    .typeError('validation-required')
    .min(new Date(), 'validation-end-date')
    .required('validation-required'),
})
